const baseClass =
  'block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset sm:text-sm sm:leading-6 mt-2';
const errorClass =
  'text-red-900 ring-red-300 placeholder:text-red-300 focus:ring-red-500';
const normalClass = 'text-gray-900 ring-gray-300 placeholder:text-gray-400';

export { baseClass, errorClass, normalClass };
